<template>
  <div class='pkg-comment'>
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-for="item in list" :key="item.id">
        <div class="content">
          <h3><img :src="item.headImg" />{{item.name}}</h3>
          <p>{{item.comment}}</p>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { pkg_comment_get } from "@/api/staticApi";
export default {
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        roundLengths: true,
        slidesPerView: 3,
        direction: "vertical",
        autoplay:4000,
        onlyExternal:true
        // loop: true,
      },
      list: []
    };
  },
  created() {
    pkg_comment_get().then(e => {
      this.list = e;
      // this.swiper.init();
      // setInterval(()=>{
      //   this.swiper.slideNext()
      // }, 2000);
      // this.swiper.updateSize();
    });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  }
};
</script>

<style scoped>
.pkg-comment {
  height: 405px;
  background: #FFF8F0;
}
.pkg-comment >>> .swiper-container {
  height: 405px;
  width: 311px;
  margin: 0 auto;
}
.content {
  background: #FFFFFF;
  border-radius: 0px 8px 8px 8px;
}
li + li {
  margin-top: 12px;
}
h3 img {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 8px;
  border-radius: 100%;
}
h3 {
  line-height: 24px;
  font-size: 14px;
  color: rgba(106, 146, 164, 1);
  padding: 12px 0 0 12px;
}
p {
  padding: 10px 22px 16px 44px;
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.pkg-comment >>> .swiper-slide {
  /* height: 130px !important; */
  /* margin-bottom: 15px; */
}
.content {
  height: 130px;
}
</style>
